import React from 'react';
import { motion } from 'framer-motion';
import { LayoutTemplate, Layers, Send } from 'lucide-react';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide5Solution({
  index
}: SlideProps) {
  const steps = [{
    icon: LayoutTemplate,
    title: 'Activate the website',
    desc: 'Snakkify DermaWorld Anzupgo pages with easy-to-digest content modules.'
  }, {
    icon: Layers,
    title: 'Build the library',
    desc: 'Turn Snakkified content into a modular, reusable campaign library.'
  }, {
    icon: Send,
    title: 'Power the outreach',
    desc: 'Deploy teasers and trailers across outbound channels.'
  }];
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-211">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(1.5rem,2.5vw,2.5rem)] flex-shrink-0 text-center" data-id="element-212">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-213">
          The Snakker Solution
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08]" data-id="element-214">
          First, we make the website work harder.
          <br data-id="element-215" />
          <span className="text-[var(--brand-green-light)]" data-id="element-216">
            Then we make the website reach further.
          </span>
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-8 min-h-0" data-id="element-217">
        <div className="col-span-4 rounded-2xl overflow-hidden shadow-lg relative" data-id="element-218">
          <img src="https://cdn.magicpatterns.com/uploads/mK7j8iC2uQVdyptCYZZirH/Screenshot_2026-06-29_at_10.12.37.png" alt="Piano" className="w-full h-full object-cover" data-id="element-219" />
          <div className="absolute inset-0 bg-[var(--brand-green)]/20 mix-blend-multiply" data-id="element-220" />
        </div>
        <div className="col-span-8 flex flex-col justify-center gap-6" data-id="element-221">
          {steps.map((step, idx) => {
          const Icon = step.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.4 + idx * 0.2,
            duration: 0.5
          }} className="bg-white rounded-2xl p-6 border border-black/5 shadow-sm flex items-center gap-6 relative overflow-hidden" data-id="element-222">
                <div className="absolute left-0 top-0 w-1.5 h-full bg-[var(--brand-green)]" data-id="element-223" />
                <div className="w-14 h-14 rounded-full bg-[var(--brand-green)]/10 flex items-center justify-center flex-shrink-0" data-id="element-224">
                  <Icon className="w-6 h-6 text-[var(--brand-green)]" data-id="element-225" />
                </div>
                <div data-id="element-226">
                  <h3 className="text-xl font-bold text-[var(--fg)] mb-1" data-id="element-227">
                    {step.title}
                  </h3>
                  <p className="text-[var(--muted)] font-medium leading-relaxed" data-id="element-228">
                    {step.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </div>;
}